import React, {useEffect, useState} from 'react';
import './index.css';
import Link from '../link';
import classnames from 'classnames';
import useWindowScroll from '../hooks/useWindowScroll';
import useWindowWidth from '../hooks/useWindowWidth';

export default function GoContactButton({
  contactsalesbutton,
  scrollTopThreshold = 0,
  style,
}) {
  const width = useWindowWidth();
  const scrollTop = useWindowScroll();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(scrollTop > scrollTopThreshold);
  }, [scrollTop, scrollTopThreshold]);

  return (
    <div>
      {contactsalesbutton && (
        <Link
          className={classnames({
            'go-contact-btn': true,
            'go-contact-btn--active': width <= 800 && enabled,
          })}
          to={'/business/contact-us/sales'}
          style={style}
        />
      )}
    </div>
  );
}
